var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.9999 42.1666C41.5688 42.1666 39.2372 41.2009 37.5181 39.4818C35.799 37.7627 34.8333 35.4311 34.8333 33C34.8333 30.5688 35.799 28.2373 37.5181 26.5182C39.2372 24.7991 41.5688 23.8333 43.9999 23.8333C46.4311 23.8333 48.7626 24.7991 50.4817 26.5182C52.2008 28.2373 53.1666 30.5688 53.1666 33C53.1666 34.2038 52.9295 35.3958 52.4688 36.5079C52.0081 37.6201 51.3329 38.6306 50.4817 39.4818C49.6305 40.333 48.62 41.0082 47.5079 41.4689C46.3957 41.9295 45.2037 42.1666 43.9999 42.1666ZM43.9999 7.33331C37.1927 7.33331 30.6643 10.0375 25.8508 14.8509C21.0374 19.6643 18.3333 26.1928 18.3333 33C18.3333 52.25 43.9999 80.6666 43.9999 80.6666C43.9999 80.6666 69.6666 52.25 69.6666 33C69.6666 26.1928 66.9624 19.6643 62.149 14.8509C57.3356 10.0375 50.8071 7.33331 43.9999 7.33331Z",
    fill: "#50C878"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.fbbce5175a31dce62afd501b8a2ad5e8.svg";
export { ForwardRef as ReactComponent };